"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.prapareContextData = exports.throwError = exports.isEnabledEnvironment = void 0;
const lodash_1 = __importDefault(require("lodash"));
const isEnabledEnvironment = (environment, environments) => {
    if (!environments) {
        return true;
    }
    return environments.includes(environment);
};
exports.isEnabledEnvironment = isEnabledEnvironment;
const throwError = (error) => {
    throw error;
};
exports.throwError = throwError;
const prepareContextDataValue = (value) => {
    if (lodash_1.default.isObject(value) || lodash_1.default.isArray(value)) {
        return JSON.stringify(value, undefined, 2);
    }
    if (typeof value === 'string') {
        return value;
    }
    if (typeof value === 'number') {
        return String(value);
    }
    return 'Invalid value';
};
const prapareContextData = (data) => {
    const contextData = {};
    if (data) {
        if (lodash_1.default.isString(data) || lodash_1.default.isNumber(data)) {
            lodash_1.default.set(contextData, 'data', data);
        }
        else {
            lodash_1.default.forEach(data, (value, key) => {
                lodash_1.default.set(contextData, key, prepareContextDataValue(value));
            });
        }
    }
    return contextData;
};
exports.prapareContextData = prapareContextData;
